import { useState } from "react";

export const localStorage = typeof window !== "undefined" ? window.localStorage : null;

const parseJSON = (json: string | null | undefined) => {
  try {
    return json ? JSON.parse(json) : undefined;
  } catch (error) {
    console.error("Error parsing JSON:", error);
    return undefined;
  }
};

export const useLocalStorage = (key: string, initialValue: any) => {
  const [value, setValue] = useState(parseJSON(localStorage?.getItem(key)) ?? initialValue);

  const setter = (newValue: any) => {
    localStorage?.setItem(key, JSON.stringify(newValue));
    setValue(newValue);
  };

  return [value, setter];
};
